import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleMerchandiseMetadata: (field: string, value: string) => void;
};

export default function AdditionalInformationFormGroup({
  album,
  readonly,
  disabled,
  handleMerchandiseMetadata,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.additionalInformation')}
        handleInput={(e) => {
          handleMerchandiseMetadata('additionalInformation', e.target.value);
        }}
        id="additionalInformation"
        type="text"
        value={album.merchandiseMetadata?.additionalInformation ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isReadOnly={readonly}
        isDisabled={disabled}
      />
    </div>
  );
}
